import React from 'react';
import { CONSTRUCTION_TYPES, ROOF_TYPES, OCCUPANCY_TYPES } from '../utils/constants';

const BuildingForm = ({ building, onChange, onRemove, index }) => {
  const handleChange = (field, value) => {
    onChange(index, { ...building, [field]: value });
  };

  return (
    <div className="building-card">
      <div className="building-header">
        <h4>Building {index + 1}</h4>
        <button 
          type="button" 
          className="btn btn-danger" 
          onClick={() => onRemove(index)}
        >
          Remove
        </button>
      </div>

      <div className="grid">
        <div className="form-group">
          <label>Total Insured Value (TIV)</label>
          <input
            type="number"
            className="form-control"
            value={building.totalInsuredValue || ''}
            onChange={(e) => handleChange('totalInsuredValue', e.target.value)}
            placeholder="Enter TIV amount"
            min="0"
          />
        </div>

        <div className="form-group">
          <label>Construction Type</label>
          <select
            className="form-control"
            value={building.construction || ''}
            onChange={(e) => handleChange('construction', e.target.value)}
          >
            <option value="">Select construction type</option>
            {CONSTRUCTION_TYPES.map(type => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Roof Type</label>
          <select
            className="form-control"
            value={building.roofType || ''}
            onChange={(e) => handleChange('roofType', e.target.value)}
          >
            <option value="">Select roof type</option>
            {ROOF_TYPES.map(type => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Roof Age (years)</label>
          <input
            type="number"
            className="form-control"
            value={building.roofAge || ''}
            onChange={(e) => handleChange('roofAge', e.target.value)}
            placeholder="Enter roof age"
            min="0"
            max="100"
          />
        </div>

        <div className="form-group">
          <label>Year Built</label>
          <input
            type="number"
            className="form-control"
            value={building.yearBuilt || ''}
            onChange={(e) => handleChange('yearBuilt', e.target.value)}
            placeholder="Enter year built"
            min="1800"
            max={new Date().getFullYear()}
          />
        </div>

        <div className="form-group">
          <label>Occupancy</label>
          <select
            className="form-control"
            value={building.occupancy || ''}
            onChange={(e) => handleChange('occupancy', e.target.value)}
          >
            <option value="">Select occupancy type</option>
            {OCCUPANCY_TYPES.map(type => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default BuildingForm;